import { render, staticRenderFns } from "./OxfordCity.vue?vue&type=template&id=d7f0a48a&scoped=true&"
import script from "./OxfordCity.vue?vue&type=script&lang=js&"
export * from "./OxfordCity.vue?vue&type=script&lang=js&"
import style0 from "./OxfordCity.vue?vue&type=style&index=0&id=d7f0a48a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f0a48a",
  null
  
)

export default component.exports